module.exports = __webpack_public_path__ + "assets/img/hyx_b.77e8577e.png";